import { formatPricingAmount } from "./pricingDisplay";

import { HIRING_LAUNCH_FREE_MODE } from "./hiringLaunchMode";

function formatJobSlotsUsed(count) {
  const used = Math.max(0, Math.floor(Number(count) || 0));
  return `${used} job slot${used === 1 ? "" : "s"} used`;
}

/**
 * @param {{ billingType?: string, prepaidJobSlots?: number, jobsRemainingThisPeriod?: number, jobsIncludedPerMonth?: number, jobsUsedThisPeriod?: number, planName?: string, periodEndsAt?: string } | null | undefined} summary
 */
export function hiringBillingStatCard(summary) {
  if (!summary || summary.billingType === "pay_as_you_go") {
    const slots = Math.max(0, Math.floor(Number(summary?.prepaidJobSlots) || 0));
    const used = Math.max(0, Math.floor(Number(summary?.prepaidJobSlotsUsed) || 0));
    if (HIRING_LAUNCH_FREE_MODE) {
      return {
        value: String(slots),
        label: "Job slots available",
        meta: formatJobSlotsUsed(used),
        cta: "View account",
        ctaMode: "account",
      };
    }
    return {
      value: String(slots),
      label: "Job slots available",
      meta: formatJobSlotsUsed(used),
      cta: slots === 0 ? "Buy job slots" : "Buy more",
      ctaMode: "buy",
    };
  }

  const remaining = Math.max(0, Math.floor(Number(summary.jobsRemainingThisPeriod) || 0));
  const used = Math.max(0, Math.floor(Number(summary.jobsUsedThisPeriod) || 0));
  const planName = String(summary.planName || "Subscription").trim() || "Subscription";
  const resetLabel = formatBillingResetDate(summary.periodEndsAt);

  return {
    value: String(remaining),
    label: "Jobs this month",
    meta: resetLabel
      ? `${formatJobSlotsUsed(used)} · ${planName} · resets ${resetLabel}`
      : formatJobSlotsUsed(used),
    cta: "Manage plan",
    ctaMode: "manage",
  };
}

/** @param {string | null | undefined} isoDate */
export function formatBillingResetDate(isoDate) {
  if (!isoDate) return "";
  const d = new Date(`${String(isoDate).slice(0, 10)}T12:00:00`);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
}

/**
 * @param {{ defaultOperatingCurrency?: string, pricing?: { oneOffAmount?: number } } | null | undefined} summary
 */
export function formatBillingOneOffPrice(summary) {
  if (summary?.pricing?.oneOffAmount == null) return "";
  return formatPricingAmount(summary.defaultOperatingCurrency, summary.pricing.oneOffAmount);
}
